/**
 * The daily wire feed.
 *
 * Every headline and every figure comes out of the tick's own state — nothing here is
 * templated with an invented number, and there is no filler. If the feed says 24% of
 * transport walked out, 24% of transport walked out.
 *
 * Shows everything up to the playhead, newest first, so scrubbing back in time genuinely
 * un-tells the story rather than leaving later events visible.
 */

import { useMemo } from 'react';
import type { RunLog, SimEvent } from 'walkout-engine';
import './Feed.css';

export function Feed({ run, day }: { run: RunLog; day: number }) {
  const events = useMemo<SimEvent[]>(() => {
    const collected: SimEvent[] = [];
    for (const snapshot of run.days) {
      if (snapshot.day > day) break;
      collected.push(...snapshot.events);
    }
    return collected.reverse();
  }, [run, day]);

  return (
    <section className="feed">
      <h2 className="feed__masthead">The Wire</h2>
      <ol className="feed__list">
        {events.map((event, index) => (
          <li
            key={`${event.day}-${event.kind}-${event.sectorId ?? ''}-${index}`}
            className={`wire wire--${event.severity} wire--${event.kind}`}
          >
            <span className="wire__day label">Day {event.day}</span>
            <h3 className="wire__headline">{event.headline}</h3>
            <p className="wire__detail">{event.detail}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
